<template>
  <div class="container" @keydown.esc="close()">
    <div class="header">
      <h2 class="title is-2" style="marginBottom: 0;">Proposal Upload Tool</h2>
      <div class="content">
        <button class="button is-primary" @click="downloadTemplate">
          Download Template File
        </button>
        <button class="button is-primary" style="marginLeft: 1rem;" @click="toUploadFiles">
          Skip to uploading proposal files
        </button>
      </div>
    </div>

    <div class="body">
      <div class="how-it-works">
        <h4 class="title is-4">How it Works</h4>
        <p>
          This tool can only be used to upload new proposals! All proposals included will be
          uploaded, so be sure you aren’t uploading duplicates. You will be able to review a summary
          of actions prior to confirming the upload.
        </p>
      </div>
      <div class="what-to-upload">
        <h4 class="title is-4">What to Upload</h4>
        <p>Upload a csv with the criteria outlined in the template file.</p>
        <p>Not all fields need to be completed, but Name is required.</p>
        <p>
          If an exact match is found for the Organization title, it will be linked to an
          organization already in our system. If not, a new organization will be created.
        </p>
        <p>
          Submitter should be email address. If an exact match is found for the email address, it
          will be linked to this user already in our system. If not, a new user will be created.
        </p>
        <p>
          Cohort Name should be an exact match to a cohort already created in the system. If no
          match is found, no cohort will be assigned. Please remove all leading and trailing spaces.
        </p>
        <p>There should be one proposal per row.</p>
        <p>Tags and evaluators cannot be added in bulk.</p>
        <p>
          The file should be in CSV format. If you are working in Excel, select ‘save as’ and choose
          CSV as the format.
        </p>
      </div>
      <div class="file-upload">
        <p class="title is-4" style="marginBottom: 1rem;">Selected File</p>
        <p v-if="selectedFile" class="has-text-weight-bold">{{ selectedFile.name }}</p>
        <p v-if="!selectedFile" class="has-text-weight-bold">No File Selected</p>
        <div class="divider"></div>
        <div class="file-upload__buttons">
          <button
            class="button"
            style="width: 10rem; marginRight: 1.5rem;"
            @click="handleUploadClick"
          >
            <input
              id="file-upload"
              type="file"
              accept=".csv"
              hidden
              ref="file"
              @change="handleUpload"
            />
            <i>Choose File</i>
          </button>
          <button
            class="button is-primary"
            @click="previewUpload()"
            :disabled="!selectedFile || dryUploading"
          >
            Preview Upload
          </button>
        </div>
      </div>
    </div>

    <!-- Confirmation Modal -->
    <div v-if="modalVisible" class="modal is-active" tabindex="0">
      <div class="modal-background"></div>
      <div class="modal-card" style="width: 75rem;">
        <header class="modal-card-head">
          <p class="modal-card-title">
            Confirmation
          </p>
        </header>

        <section class="modal-card-body">
          <div v-if="!uploading">
            <div class="content">
              <p>The file you uploaded contains:</p>
              <p>
                - {{ dryRunInfo.toCreate.length }} new proposals (these will be added to the
                database)
              </p>
              <p v-if="dryRunInfo.invalidRows.length" class="has-text-danger">
                There were errors in the uploaded spreadsheet, please review the following row
                numbers:
                <span v-for="(num, index) in dryRunInfo.invalidRows" :key="index">{{ num }}</span>
              </p>
              <p v-html="this.theseErrors"></p>
              <p>Please confirm to proceed with the changes outlined above.</p>
            </div>
          </div>
          <LoadingBox v-if="uploading" />
        </section>
        <footer class="modal-card-foot">
          <button class="button" @click="reload()" :disabled="uploading">Cancel</button>
          <button
            class="button is-primary"
            @click="uploadApplications()"
            :disabled="uploading || (dryRunInfo && dryRunInfo.invalidRows.length > 0)"
          >
            Submit
          </button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
/*
  NOTE: The terms Proposal and Application are used interchangeably throughout this application.
*/
import Application from '@/services/applications'

import LoadingBox from '@/components/LoadingBox'

export default {
  name: 'StaffUploadApplications',
  components: {
    LoadingBox,
  },
  data() {
    return {
      isUploadDisabled: false,
      selectedFile: null,
      modalVisible: false,
      dryUploading: false,
      uploading: false,
      dryRunInfo: null,
      theseErrors: ""
    }
  },
  methods: {
    downloadTemplate() {
      window.open('/static/upload-proposals-template.csv')
    },
    handleUploadClick() {
      document.getElementById('file-upload').click()
    },
    handleUpload(e) {
      this.selectedFile = e.target.files[0]
    },
    async actualPreviewUpload(file) {
      try{
        this.dryUploading = true
          const response = await Application.api.uploadApplicationsDryRun(file)
          this.dryRunInfo = response
          //console.log("this.dryRunInfo")
          //console.log(this.dryRunInfo)
          this.modalVisible = true
      }
      catch (err) {
        console.log(err)
        this.$Alert.alert({
          type: 'error',
          message: `<p>Error Uploading CSV</p>`,
          timeout: 6000,
        })
      } finally {
        this.dryUploading = false
      }
    },
    async previewUpload() {
      try {
        //console.log("this.selectedFile")
        //console.log(this.selectedFile)
        /////
        const blahblah = await new Response(this.selectedFile).text()
        var blahLines = blahblah.split("\n");
        
        //console.log("blahblah")
        //console.log(blahblah)
        var datatoSend= blahblah.replace(/[\x00-\x08\x0E-\x1F\x7F-\uFFFF]/g, '')        
        var dataLines = datatoSend.split("\n");
        var linesChanged = 0;
        for (let i = 0; i < dataLines.length; i++) {
          if (dataLines[i].length != blahLines[i].length)
          {
            //console.log("data:"+blahLines[i].length+","+dataLines[i].length);
            this.theseErrors = this.theseErrors + "<p><b>Changed From</b>:</p><p>"+blahLines[i]+"</p><p><b>Changed To</b>:</p><p>"+dataLines[i]+"</p><p>---------------------</p>";
            linesChanged++;
          }
        }
        if (linesChanged > 0)
        {
          this.theseErrors = "<p>"+linesChanged+" line(s) changed:</p>"+this.theseErrors
        }
        //console.log("datatoSend")
        //console.log(datatoSend)
        var blob = new Blob([datatoSend], { type: 'application/vnd.ms-excel' });
        var file = new File([blob], "foo.csv", {type: "application/vnd.ms-excel"});
        
        this.dryUploading = true
        //const response = await Application.api.uploadApplicationsDryRun(this.selectedFile)
        const response = await Application.api.uploadApplicationsDryRun(file)
        this.dryRunInfo = response
        //console.log("this.dryRunInfo")
        //console.log(this.dryRunInfo)
        this.modalVisible = true
        
      } catch (err) {
        console.log(err)
        this.$Alert.alert({
          type: 'error',
          message: `<p>Error Uploading CSV</p>`,
          timeout: 6000,
        })
      } finally {
        this.dryUploading = false
      }
    },
    // Modal methods
    async uploadApplications() {
      try {
        this.uploading = true

        const blahblah = await new Response(this.selectedFile).text()
        
        //console.log("blahblah")
        //console.log(blahblah)
        var datatoSend= blahblah.replace(/[\x00-\x08\x0E-\x1F\x7F-\uFFFF]/g, '')
        //console.log("datatoSend")
        //console.log(datatoSend)
        var blob = new Blob([datatoSend], { type: 'application/vnd.ms-excel' });
        var file = new File([blob], "foo.csv", {type: "application/vnd.ms-excel"});
        

        const response = await Application.api.uploadApplications(file)

        // Reset state
        this.selectedFile = null
        this.dryRunInfo = null
        this.close()

        this.$Alert.alert({
          type: 'info',
          message: `<p>${response.applicationsCreated} Applications Uploaded!</p>`,
          timeout: 6000,
        })
        this.toUploadFiles()
      } catch (err) {
        //console.log(err)
        this.$Alert.alert({
          type: 'error',
          message: `<p>Error Uploading CSV</p>`,
          timeout: 6000,
        })
      } finally {
        this.uploading = false
      }
    },
    close() {
      this.modalVisible = false
    },
    reload() {
      location.reload();
    },
    toUploadFiles() {
      this.$router.push({ name: 'StaffUploadApplicationFiles' })
    },
  },
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 4rem 0 3rem 0;
}

.how-it-works {
  margin-bottom: 2rem;

  p {
    margin-bottom: 1rem;
  }
}

.what-to-upload {
  margin-bottom: 2rem;
  p {
    margin-bottom: 1rem;
  }
}

.file-upload {
  &__buttons {
    display: flex;
    align-items: center;
    margin-top: 2rem;
  }
}

.divider {
  height: 1px;
  border: 1px solid lightgray;
  width: 20rem;
}
</style>
